import styled from 'styled-components'

export const TooltipListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-inline-start: 1rem;
  margin: 0;
`
